import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Button, Spin } from "antd";
import { ReactComponent as BackIcon } from "../../../assets/back-icon.svg";
import ProjectDetailsSection from "./projectDetailsSection";
import { fetchProject, projectDetailCleanupFunc } from "../redux/actions";
import UseSupAdminOrAdminWithUserManagerPermission from "../../../components/useSupAdminOrAdminWithUserManagerPermission";
import { fetchProjectStatuses } from "../../ProjectStatuses/redux/actions";
import "./index.less";
import ProjectNotifications from "./projectNotifications";

const ProjectDetail = () => {
  const [isProjectUpdate, setIsProjectUpdate] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  let canEditEveryThing = UseSupAdminOrAdminWithUserManagerPermission();
  const [canUpdate, setCanUpdate] = useState(false);

  const { currentProjectObj, fetchProjectDetailLoading } = useSelector(
    (state) => state.projectsSetupReducer
  );
  const { user } = useSelector((state) => state.authReducer);

  useEffect(() => {
    if (currentProjectObj?.id) {
      setIsProjectUpdate(true);
    }
  }, [currentProjectObj]);

  useEffect(() => {
    if (params?.id) {
      setIsProjectUpdate(true);
      dispatch(fetchProject(params?.id));
    } else if (pathname === "/profile") {
      setIsProjectUpdate(true);
      dispatch(fetchProject(user.id));
    }

    return () => {
      dispatch(projectDetailCleanupFunc());
    };
  }, [params.id]);

  useEffect(() => {
    if (user?.permissions?.project_setup?.add_edit) {
      setCanUpdate(true);
    }
  }, [user]);

  useEffect(() => {
    dispatch(fetchProjectStatuses({ search: {} }));
  }, []);

  return (
    <div className="page-top-div heading-parent-div">
      <Row justify="space-between">
        <Col>
          <span className="text-span">
            {isProjectUpdate ? "Update Project" : "Add Project"}
          </span>
        </Col>
        {/* {!isProfileCase && ( */}
        <Col>
          <Button
            onClick={() => navigate("/projects-setup")}
            icon={<BackIcon width={24} height={14} />}
            className="back-btn"
            size="middle"
          >
            BACK
          </Button>
        </Col>
        {/* )} */}
      </Row>
      <Spin spinning={fetchProjectDetailLoading}>
        <div className="user-manager-parent-div">
          <ProjectDetailsSection
            isProjectUpdate={isProjectUpdate}
            canUpdate={canUpdate}
          />
          {false && (
            <ProjectNotifications
              isProjectUpdate={isProjectUpdate}
              canUpdate={canUpdate}
            />
          )}
        </div>
      </Spin>
    </div>
  );
};

export default ProjectDetail;
